var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TestItem",on:{"click":function($event){return _vm.link(_vm.id)}}},[_c('p',{staticClass:"item-user-info"},[_vm._v(_vm._s(_vm.patient.name)+"/"+_vm._s(_vm.patient.sex==='M'?'男':'女')+"/"+_vm._s(_vm.patient.age)+"岁")]),_c('p',{staticClass:"item-title van-ellipsis"},[_vm._v(_vm._s(_vm.tradeName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }